
export default class GameCompleteResponse {

  constructor(
    private data: RawResponse
  ) {}

  get prize(): Prize|null {

    const prizeData = this.data.prize
    if (!prizeData) {
      return null
    }

    return new Prize(prizeData.imageUrl, prizeData.prizeValue)
  }
}

interface RawResponse {
  prize?: {
    imageUrl: string,
    prizeValue: number,
  }
}

export class Prize {
  constructor(
    public readonly imageUrl: string,
    public readonly prizeValue: number
  ) {}
}
